import React from 'react'
import { ToolPopupContainerProps } from './ToolPopupContainer.types'
import styles from './ToolPopupContainer.module.scss'
import cl from 'classnames'
import { PopupContainer } from '../PopupContainer'
import { SectionContainer } from '../SectionContainer'
import { Numbers } from '../Numbers'
import { CloseButton } from '../CloseButton'
import { HorizontalLine } from '../HorizontalLine'
import { Button } from '../Button'

const ToolPopupContainerComponent = (props: ToolPopupContainerProps) => {
  const {
    className,
    style,
    children,
    onClose,
    bottomButtonsProps,
    title
  } = props

  return (
    <PopupContainer>
      <SectionContainer className={cl(styles.container, className)} style={style}>
        <div className={styles.header}>
          <Numbers>{title}</Numbers>
          <CloseButton onClick={onClose} />
        </div>

        {children}

        {bottomButtonsProps && (
          <>
            <HorizontalLine />

            <div className={styles.buttonsContainer}>
              {bottomButtonsProps.map((buttonProps, index) => {
                return (
                  <Button key={index} {...buttonProps} />
                )
              })}
            </div>
          </>
        )}
      </SectionContainer>
    </PopupContainer>
  )
}

const ToolPopupContainer = ToolPopupContainerComponent
export { ToolPopupContainer }
